import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import { ModalAffiliateContactForm } from './widget/component/modals';
import ContactForm from './widget/component/ContactForm';

const initSpecificPageWidgets = () => {
    const props = {
        endpoints,
    };

  initWidget('modal-affiliate-contact-form', ModalAffiliateContactForm, props);
  initWidget('contact-form', ContactForm, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpecificPageWidgets.bind(this));
} else {
    initSpecificPageWidgets();
}